import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { Container } from '@eliadmin/core/src/components/ui/container';
import { ProductAttachment } from '@eliadmin/core/src/components/product/detail/product-attachment';

export function ProductTabAttachments() {
  const product = useVariantsStore(s => s.product);

  const { t } = useTranslations();

  return (
    <Container className={cn('flex flex-col gap-3 px-2', 'ea-product-detail-tab-accessories')}>
      <h2 className="mb-2 text-2xl font-bold">Zloženie</h2>
      {product.attachments?.map((attachment, index) => (
        <ProductAttachment key={index} attachment={attachment} />
      ))}
    </Container>
  );
}
